import ComponentFactory from './ComponentFactory';
import Icons from './utils/Icons';

class Main {
  constructor() {
    this.init();
  }

  init() {
    document.documentElement.classList.add('has-js');
    // console.log(document);
    new ComponentFactory();
    Icons.load();
  }
}
new Main();
